import React from 'react';
import { categoryStyles, getCategoryByTag } from '../constants/identities';

interface IdentityTagProps {
  tag: string;
  variant?: 'standard' | 'profile' | 'card';
}

export const IdentityTag = ({ tag, variant = 'standard' }: IdentityTagProps) => {
  // Normalize variations to the joint canonical name
  const normalizedTag = (tag === 'Mandinka' || tag === 'Malinke' || tag === 'Mandinka/Malinke') 
    ? 'Malinke/Mandinka' 
    : (tag === 'Soninke' || tag === 'Sarahule' || tag === 'Soninke/Sarahule')
    ? 'Soninke/Sarahule'
    : (tag === 'Diola' || tag === 'Jola' || tag === 'Diola/Jola')
    ? 'Diola/Jola'
    : (tag === 'Dyula' || tag === 'Dioula' || tag === 'Dyula/Dioula')
    ? 'Dyula/Dioula'
    : (tag === 'Vodun' || tag === 'Voodoo' || tag === 'Voodoo/Vodun')
    ? 'Voodoo/Vodun'
    : (tag === 'Fulani' || tag === 'Peul' || tag === 'Fulani/Peul')
    ? 'Fulani/Peul'
    : tag;

  const category = getCategoryByTag(normalizedTag);
  const theme = categoryStyles[category] || categoryStyles['Interests'];

  // Standard: uniform blue pill — fully inline to guarantee consistent rendering
  if (variant === 'standard') {
    return (
      <span style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '5px 14px',
        fontSize: '12px',
        fontWeight: 500,
        color: '#60a5fa',
        borderRadius: '1rem',
        border: '1px solid rgba(96, 165, 250, 0.3)',
        background: 'rgba(96, 165, 250, 0.1)',
        whiteSpace: 'nowrap',
      }}>
        {normalizedTag}
      </span>
    );
  }

  // Card variant: compact gradient pill for dark photo overlays (Discover cards)
  if (variant === 'card') {
    return (
      <span style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '5px 12px',
        fontSize: '11px',
        fontWeight: 800,
        color: '#ffffff',
        borderRadius: '1rem',
        backgroundImage: theme.gradient,
        boxShadow: '0 2px 8px rgba(0,0,0,0.35), inset 0 0 0 1px rgba(0,0,0,0.2)',
        textShadow: '0 1px 2px rgba(0,0,0,0.9)',
        whiteSpace: 'nowrap',
      }}>
        {normalizedTag}
      </span>
    );
  }

  // Profile Specific: High Impact, Bold, Colored
  return (
    <div style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundImage: theme.gradient,
      textShadow: '0 1px 3px rgba(0,0,0,0.8)',
      boxShadow: '0 10px 15px -3px rgba(0,0,0,0.25), inset 0 0 0 1.5px rgba(0,0,0,0.18)',
      minWidth: '6rem',
      padding: '14px 24px',
      fontSize: '0.875rem',
      fontWeight: 900,
      color: '#ffffff',
      borderRadius: '1rem',
      whiteSpace: 'nowrap',
    }}>
      {normalizedTag}
    </div>
  );
};
